import { Button, Popconfirm, Row, Space } from "antd";
import Servico from "../../../../../Models/Financeiro/Faturamento/Servico";
import ServicoServices from "../../../../../Services/Financeiro/Faturamento/ServicoServices";
import { Ordenar } from "../../../../../Utils/Ordenacao";
import { ResponsiveAntdTable } from "../../../../ResponsiveAntdTable";
import ComponentePermissao from "../../../../Base/Permissao/ComponentePermissao";
import { PermissoesKey } from "../../../../../Constants/Permissoes";

interface IServicoTableProps {
    isDesativar?: boolean,
    isAtivar?: boolean,
    onEditar?: (servico:Servico) => void,
    filtros?: {servico?:Servico}
}

export default function ServicoTable({
    isDesativar,
    isAtivar,
    onEditar,
    filtros
}: IServicoTableProps) {
    isDesativar = isDesativar ?? true;
    isAtivar = isAtivar ?? true;

    const {
        data,
        isLoading
    } = ServicoServices.useListar({
        servico : filtros?.servico ?? {} as Servico
    });

    const {
        mutate : mutateDesativar,
        isPending : isPedingDesativar
    } = ServicoServices.useDesativar({

    });

    const {
        mutate: mutateAtivar,
        isPending: isPedingAtivar
    } = ServicoServices.useAtivar({

    });

    return <ResponsiveAntdTable<Servico>
        bordered
        locale={{ emptyText: 'Nenhum certificado encontrado.' }}
        dataSource={data}
        loading={isLoading || isPedingDesativar || isPedingAtivar}
        rowKey={(k) => k.codigo}
        addTitleOn="lg"
        columns={[
            {
                title: "Código",
                dataIndex: "codigo",
                sorter: (a, b) => Ordenar.Numero(a.codigo, b.codigo),
                key: "codigo"
            },
            {
                title: "Nome",
                dataIndex: "nome",
                render: (_, servico) => servico.nome,
                sorter: (servicoL, servicoR) => Ordenar.String(servicoL.nome, servicoR.nome),
                key: "nome"
            },
            {
                title: "Código do serviço",
                dataIndex: "codigoServico",
                render: (value:number) => value.toString(),
                sorter: (servicoL, servicoR) => Ordenar.Numero(servicoL.codigoServico, servicoR.codigoServico),
                key: "codPessoa"
            },
            {
                title: "Ativo",
                dataIndex: ["ativo"],
                render: (_, servico) => <>{servico.ativo ? "Sim" : "Não"}</>,
                sorter: (servicoL, servicoR) => Ordenar.Booleano(servicoL.ativo, servicoR.ativo),
                key: "codPessoa"
            },
            {
                title: "Ações",
                render: (_, servico) => <>
                    <Row wrap>
                        <Space size="small">
                            <ComponentePermissao permissoes={["FinanceiroFaturamentoServicoDesativar"]}>
                                {isDesativar && servico.ativo && <Popconfirm
                                    title="Desativar"
                                    description="Tem certeza que desja desativar este serviço?"
                                    onConfirm={() => {
                                        mutateDesativar(servico.codigo);
                                    }}
                                >
                                    <Button
                                        type='primary'
                                        danger
                                        size='small'
                                        style={{ width: "min-content" }}
                                    >
                                        Desativar
                                    </Button>
                                </Popconfirm>}
                            </ComponentePermissao>
                            <ComponentePermissao permissoes={["FinanceiroFaturamentoServicoAtivar"]}>
                                {isAtivar && !servico.ativo && <Popconfirm
                                    title="Ativar"
                                    description="Tem certeza que desja ativar este serviço?"
                                    onConfirm={() => {
                                        mutateAtivar(servico.codigo);
                                    }}
                                >
                                    <Button
                                        type='dashed'
                                        size='small'
                                    >Ativar</Button>
                                </Popconfirm>}
                            </ComponentePermissao>
                            <ComponentePermissao permissoes={["FinanceiroFaturamentoServicoAlterar"]}>
                                {
                                    !!onEditar && <Button
                                        type='primary'
                                        size='small'
                                        style={{ width: "min-content" }}
                                        onClick={(ev) => onEditar?.(servico)}
                                    >
                                        Editar
                                    </Button>
                                }
                            </ComponentePermissao>
                        </Space>
                    </Row>
                </>,
                key: "acoes"
            }
        ]}
    />;
}